<template>
  <div class="form-login">
    <BForm
      @submit.prevent="onLogin"
    >
      <h5 class="mb-3">{{ message }}</h5>
      <BFormInput
        id="form-login__username"
        v-model="username"
        class="mb-3"
        :state="stateUsername"
        placeholder="Namen wählen"
        trim
      />
      <BButton
        type="submit"
        variant="primary"
        :disabled="!stateUsername || isLoggingIn"
      >
        Los geht's!
      </BButton>
    </BForm>
  </div>
</template>

<script>
export default {
  name: 'FormLogin',
  props: {
    message: {
      type: String,
      default: 'Namen wählen',
    },
  },
  data() {
    return {
      username: null,
      isLoggingIn: false,
    };
  },
  computed: {
    stateUsername() {
      if (this.username == null) {
        return null;
      }
      return this.username.length >= 3;
    },
  },
  methods: {
    async onLogin() {
      this.isLoggingIn = true;
      await this.$store.dispatch('auth/loginAnonymous', {
        username: this.username,
      });
      this.isLoggingIn = false;
    },
  },
};
</script>

<style scoped>

</style>
